export default __webpack_public_path__ + "static/media/TH.a65cc9bc.svg";